import React from 'react';
import {
  Box,
  TextField,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { FilenameInputProps } from './types';
import { useFilenameInput } from './useFilenameInput';

const FilenameInput: React.FC<FilenameInputProps> = props => {
  const {
    textFieldRef,
    menuAnchorEl,
    isMenuOpen,
    preview,
    variables,
    handleOpenMenu,
    handleCloseMenu,
    handleVariableClick,
    handleTextFieldChange,
    handleTextFieldClick,
  } = useFilenameInput(props);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
        <TextField
          inputRef={textFieldRef}
          label="Filename Template"
          value={props.value}
          onChange={handleTextFieldChange}
          onClick={handleTextFieldClick}
          fullWidth
          placeholder="Enter filename template"
          helperText="Use variables like {portfolio_name}, {report_type}, {from_date}, {to_date}"
        />
        <IconButton
          onClick={handleOpenMenu}
          color="primary"
          sx={{ mt: 1 }}
          aria-label="Insert variable"
        >
          <AddCircleOutlineIcon />
        </IconButton>
      </Box>

      <Menu
        anchorEl={menuAnchorEl}
        open={isMenuOpen}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {variables.map(variable => (
          <MenuItem
            key={variable.value}
            onClick={() => handleVariableClick(variable.value)}
          >
            <Box>
              <Typography variant="body2" fontWeight={500}>
                {variable.label}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {variable.description}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          fontSize: '0.875rem',
          fontStyle: 'italic',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        Preview: {preview}
      </Typography>
    </Box>
  );
};

export default FilenameInput;
